import { api } from './http';

export const APPLICANT_UPLOAD_URL = '/api/applicant/upload-document';
export const APPLICANT_FILE_UPDATE_URL = '/api/applicant/file-update';

export function mapUploadResponse(response, uploadType) {
  const payload = response?.data ?? response ?? {};

  return {
    file_url: payload.url ?? '',
    file_name: payload.filename ?? payload.key ?? '',
    file_size: payload.size ?? 0,
    upload_type: uploadType,
  };
}

export async function uploadApplicantDocument(file, uploadType) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post(APPLICANT_UPLOAD_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return mapUploadResponse(response, uploadType);
}

export async function updateApplicantDocument(file, uploadType, previousKey) {
  const formData = new FormData();
  formData.append('file', file);

  if (previousKey) {
    formData.append('file_name', previousKey);
  }

  const response = await api.post(APPLICANT_FILE_UPDATE_URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const payload = response?.data ?? response ?? {};

  return {
    file_url: payload.url ?? payload.data?.url ?? '',
    file_name: payload.filename ?? payload.key ?? payload.data?.filename ?? '',
    file_size: payload.size ?? payload.data?.size ?? 0,
    upload_type: uploadType,
  };
}
